import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import { Form, Formik } from "formik";
import Footer from "../../../Components/Footer/footer";
import CustomSelect from "../../../CustomComponent/custom_select";
import { useSelector } from "react-redux";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { podCastInfo } from "../../../SchemaInfo/info";
import { podCastSchema } from "../../../Schemas/Media And Marketing/podcast.schema";
import { FcClapperboard, FcCollaboration } from "react-icons/fc";
import CustomCheckbox from "../../../CustomComponent/custom_checkbox";
import { useEffect } from "react";

const Addpodcast = () => {
  const store = useSelector((store) => store.login.user);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [socialMedia, setSocialMedia] = useState([]);
  const [guest, setGuest] = useState([]);

  console.log("store user", store);

  const handelSubmit = (values) => {
    values = { ...values, userId: store?.UserId };
    setLoading(true);
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    performRequest("POST", `/podcast/create-podcast`, values, headers)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Podcast created successfully!");
          navigate(`/podcasts`);
        } else {
          Toast("error", "Error while creating podcast");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/podcast/social-media-users`)
      .then((res) => {
        if (res.status === 200) {
          setSocialMedia(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting social media!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/guest/get-all-guest`)
      .then((res) => {
        if (res.status === 200) {
          setGuest(res.data);
          // console.log(buyersManagementInfo);
        } else {
          Toast("error", "Error while getting guests!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcCollaboration></FcCollaboration> Podcast
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title ">Create New Podcast</h2>
            </div>
            <Formik
              initialValues={podCastInfo}
              validationSchema={podCastSchema}
              onSubmit={handelSubmit}
              enableReinitialize={true}
            >
              {(props) => (
                <Form>
                  <div className="card-body">
                    {/* <h3> Planning Podcast (Create Podcast)</h3>
                    <hr className=""></hr> */}
                    {/* {console.log('props',props)} */}

                    {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="podcastName"
                        ></CustomInput>
                        {props.touched.podcastName &&
                          props.errors.podcastName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastName}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="podcastDescription"
                        ></CustomTextArea>
                      </div>
                    </div> */}

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Branding Assets
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastBrand"
                          className="form-control"
                        >
                          <option value="">Select</option>
                          <option value="Kryzen Biotech">
                            Kryzen Biotech{" "}
                          </option>
                          <option value="Hydroponic Masterclass">
                            Hydroponic Masterclass
                          </option>
                          <option value="Sudhir Devkar">Sudhir Devkar</option>
                          <option value="Eat Pure Greens">
                            Eat Pure Greens
                          </option>
                        </CustomSelect>

                        {props.touched.podcastBrand &&
                          props.errors.podcastBrand && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastBrand}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Guest Name
                      </label>
                      <div className="w-100 col">
                
                        <CustomSelect name="guestName">
                          <option value="">Select</option>
                          {guest?.map((item, index) => {
                            return (
                              <option key={index} value={item?.guestName}>
                                {item?.guestName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Type
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastType"
                          className="form-control"
                        >
                          <option value="">Select Podcast Type</option>
                          <option value="Single Guest">Single Guest</option>
                          <option value="Multiple Guest">Multiple Guest</option>
                        </CustomSelect>

                        {props.touched.podcastType &&
                          props.errors.podcastType && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastType}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Language
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastLanguage"
                          className="form-control"
                        >
                          <option value="">Select Language</option>
                          <option value="Hindi">Hindi</option>
                          <option value="Marathi">Marathi</option>
                          <option value="English">English</option>
                        </CustomSelect>

                        {props.touched.podcastLanguage &&
                          props.errors.podcastLanguage && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastLanguage}{" "}
                            </p>
                          )}
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Series Name
                      </label>
                      <div className="w-100 col">
                        <CustomSelect
                          name="podcastseriesName"
                          className="form-control"
                        >
                          <option value="">Select Type</option>
                          <option value="Marathi - खरं बोलायचं तर (policy makers, government officials, activists)">
                            Marathi: खरं बोलायचं तर (policy makers, government
                            officials, activists)
                          </option>
                          <option value="Marathi - खरा खेळ (Business people)">
                            Marathi: खरा खेळ (Business people)
                          </option>
                          <option value="Marathi - अन्नदाता (Farmers)">
                            Marathi: अन्नदाता (Farmers)
                          </option>
                          <option value="Hindi - सच की बात (policy makers, government officials, activists)">
                            Hindi : सच की बात (policy makers, government
                            officials, activists)
                          </option>
                          <option value="Hindi - असली खेल (Business people)">
                            Hindi - असली खेल (Business people)
                          </option>
                          <option value="Hindi - कारोबारी किसान (Farmers)">
                            Hindi - कारोबारी किसान (Farmers)
                          </option>
                          <option value="English - (Policy Makers / Government / Activists)">
                            English - (Policy Makers / Government / Activists)
                          </option>
                          <option value="English - (Business People)">
                            English - (Business People)
                          </option>
                          <option value="English - (Farmers)">
                            English - (Farmers)
                          </option>
                        </CustomSelect>

                        {props.touched.podcastseriesName &&
                          props.errors.podcastseriesName && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.podcastseriesName}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Planning Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="podcastDate"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Guest Previous podcast reference
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          className="form-control"
                          name="guestPrvRef"
                        ></CustomInput>
                        {props.touched.guestPrvRef &&
                          props.errors.guestPrvRef && (
                            <p className="text-danger">
                              {" "}
                              {props.errors.guestPrvRef}{" "}
                            </p>
                          )}
                      </div>
                    </div>

                    {/* <hr></hr>
                    <h3>Podcast Shooting (In Edit Podcast)</h3>
                    <hr></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Venue
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="podcastVenue"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Shooting Date
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"date"}
                          className="form-control"
                          name="shootingDate"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Questions
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="podcastQuestions"
                        ></CustomTextArea>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Camera Name & Lens Name
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="cameraName"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Raw Podcast Folder Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="rawFolderPath"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Credits
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="podcastCredits"
                        ></CustomTextArea>
                      </div>
                    </div>

              

                 <hr></hr>
                 <h3>Podcast Editing (In Edit Podcast)</h3>
                 <hr></hr>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Editor Name
                      </label>
                      <div className="w-100 col">
            
                        <CustomSelect name="podcastEditor">
                          <option value="">Select</option>
                          {socialMedia?.map((item, index) => {
                            return (
                              <option key={index} value={item?.userName}>
                                {item?.userName}
                              </option>
                            );
                          })}
                        </CustomSelect>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Coming Soon Poster
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "podCastComingSoonPoster",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.podCastComingSoonPoster &&
                          props.errors.podCastComingSoonPoster && (
                            <p className="text-danger">
                              {props.errors.podCastComingSoonPoster}
                            </p>
                          )}
                      </div>
                    </div>

                 
                    

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Podcast Thumbnail
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "rowImageGuest",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.rowImageGuest &&
                          props.errors.rowImageGuest && (
                            <p className="text-danger">
                              {props.errors.rowImageGuest}
                            </p>
                          )}
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Podcast First Draft File Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="podcastFirstDraft"
                        ></CustomInput>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className=" w-25 form-label col-3">
                        Podcast edit complated
                      </label>
                      <div className="w-100 col">
                        <CustomCheckbox
                          name={`ispodcastComplated`}
                          type="checkbox"
                          height={"20px"}
                          width={"20px"}
                        ></CustomCheckbox>
                        {props.touched.ispodcastComplated &&
                          props.errors.ispodcastComplated && (
                            <p className="text-danger">
                              {props.errors.ispodcastComplated}
                            </p>
                          )}
                      </div>
                    </div>



                    <hr></hr>
                    <h3>Podcast Final (In Edit Podcast)</h3>
                    <hr></hr>


                  

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Podcast Final Footage Path
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="podCastFinalFootage"
                        ></CustomInput>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                      Podcast Publish Title
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type={"text"}
                          className="form-control"
                          name="podCastPublishTitle"
                        ></CustomInput>
                      </div>
                    </div>

                      <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Podcast Publish Description
                      </label>
                      <div className="w-100 col">
                        <CustomTextArea
                          type={"text"}
                          className="form-control"
                          name="podCastPublishDescription"
                        ></CustomTextArea>
                      </div>
                    </div>

                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Mark as Published (Upload proof)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          name=""
                          type="file"
                          onChange={(e) =>
                            props.setFieldValue(
                              "markAsPublished",
                              e.target.files[0]
                            )
                          }
                        />
                        {props.touched.markAsPublished &&
                          props.errors.markAsPublished && (
                            <p className="text-danger">
                              {props.errors.markAsPublished}
                            </p>
                          )}
                      </div>
                    </div>*/}
                  </div> 
                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <FormSubmitButton buttonText="Create New Podcast" />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};
export default Addpodcast;
